import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {GespeichertesPortfolioData} from '../components/fonds/fondstable-gespeichertes-portfolio/fonds-table-gespeichertes-portfolio.component';

@Injectable()
export class EventFondsService {
  public selectedVermittlerspezifischesPortfolioInvestitionsbetrag$ = new ReplaySubject<GespeichertesPortfolioData>(1);
  public selectedVermittlerspezifischesPortfolioZuzahlung$ = new ReplaySubject<GespeichertesPortfolioData>(1);
  private _isInitialCheckVermittlerspezifischesPortfolioExecutedInvestitionsbetrag: boolean = false;
  private _isInitialCheckVermittlerspezifischesPortfolioExecutedZuzahlung: boolean = false;

  public init() {
    const data = {} as GespeichertesPortfolioData;
    data.feldnameExtern = null;
    data.wertEingabe = null;
    this.selectedVermittlerspezifischesPortfolioInvestitionsbetrag$.next(data);
    this.selectedVermittlerspezifischesPortfolioZuzahlung$.next(data);
    this._isInitialCheckVermittlerspezifischesPortfolioExecutedInvestitionsbetrag = false;
    this._isInitialCheckVermittlerspezifischesPortfolioExecutedZuzahlung = false;
  }

  public getInitialCheckVermittlerspezifischesPortfolioExecuted(kontext: string): boolean {
    if ('/PortfoliovorlageID' === kontext) {
      return this._isInitialCheckVermittlerspezifischesPortfolioExecutedInvestitionsbetrag;
    }
    if ('/PortfoliovorlageZuzahlungID' === kontext) {
      return this._isInitialCheckVermittlerspezifischesPortfolioExecutedZuzahlung;
    }
    return null;
  }

  public setInitialCheckVermittlerspezifischesPortfolioExecuted(kontext: string): void {
    if ('/PortfoliovorlageID' === kontext) {
      this._isInitialCheckVermittlerspezifischesPortfolioExecutedInvestitionsbetrag = true;
    }
    if ('/PortfoliovorlageZuzahlungID' === kontext) {
      this._isInitialCheckVermittlerspezifischesPortfolioExecutedZuzahlung = true;
    }
  }
}
